import { APIClientError } from './api-client-error';

export class UnauthorizedError extends APIClientError {
  public constructor() {
    super('Unauthorized', 401, 'Unauthorized');
    this.name = 'UnauthorizedError';
  }
}
